import React from "react";
import { motion } from "framer-motion";
import { ListFilter, Columns3, Repeat, Clock, Tag, Users } from "lucide-react";
import { useNavigate } from "react-router-dom";
// office hub css 9121 to 9370
export default function Powerful_features_Titles() {
  const navigate = useNavigate();
  return (
    <>
      <section className="powerful-features">
        <div className="powerful-features__container">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="powerful-features__header"
          >
            <h2 className="powerful-features__title">Everything You Need</h2>
            <p className="powerful-features__subtitle">
              Powerful features for effortless task management
            </p>
          </motion.div>

          <div className="powerful-features__grid">
            {[
              {
                icon: ListFilter,
                title: "Advanced Filtering",
                description:
                  "Filter by any column. Apply multiple filters simultaneously for precise results.",
                gradient: "powerful-features__icon--blue",
              },
              {
                icon: Columns3,
                title: "Column Customization",
                description:
                  "Add unlimited columns, show/hide any field, and reorder with drag-and-drop.",
                gradient: "powerful-features__icon--purple",
              },
              {
                icon: Users,
                title: "Bulk Operations",
                description:
                  "Select multiple tasks and update status, assignees, dates, and more in one click.",
                gradient: "powerful-features__icon--green",
              },
              {
                icon: Tag,
                title: "Custom Statuses",
                description:
                  "4 parent statuses with unlimited child statuses. Create workflows your way.",
                gradient: "powerful-features__icon--orange",
              },
              {
                icon: Clock,
                title: "Time Tracking",
                description:
                  "Log hours and minutes with detailed notes. Track time across multiple assignees.",
                gradient: "powerful-features__icon--indigo",
              },
              {
                icon: Repeat,
                title: "Recurring Tasks",
                description:
                  "Automate repetitive work with monthly, weekly, or custom recurring schedules.",
                gradient: "powerful-features__icon--pink",
              },
            ].map((feature, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="powerful-features__card"
              >
                <div
                  className={`powerful-features__icon-wrapper ${feature.gradient}`}
                >
                  <feature.icon className="powerful-features__icon" />
                </div>
                <h3 className="powerful-features__card-title">
                  {feature.title}
                </h3>
                <p className="powerful-features__card-description">
                  {feature.description}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* css is 9371 to 9615 */}
      <section className="ready-cta">
        <div className="ready-cta__container">
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            className="ready-cta__content"
          >
            <h2 className="ready-cta__title">Ready to Get Organized?</h2>
            <p className="ready-cta__subtitle">
              Join thousands of teams managing tasks effortlessly with
              Simplifyte
            </p>
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="ready-cta__button"
              // onClick={() => navigate("app.simplifyte.com/login")}
              onClick={() => {
                window.location.href = "https://app.simplifyte.com/login";
              }}
            >
              Start Free Trial
            </motion.button>
          </motion.div>
        </div>
      </section>
    </>
  );
}
